import { Container } from 'theme-ui';

import Slider from 'react-slick';
import '~/styles/custom-slick.css';
import '~/styles/custom-slick-theme.css';
import ChevronRightIcon from '~/assets/images/icons/chevron-right.svg';
import { cloneElement, isValidElement, useState } from 'react';
import SliderButton from '~/components/Generic/ImageCarousel/SliderButton';

const GenericSlider = ({ children, length, forwardSx = {}, arrowSx = {}, sliderSettings = {} }) => {
  // Pass down a state to child component to determine whether or not slider is in a dragging state
  // (good for disabling events while dragging)
  const [dragging, setDragging] = useState(false);
  return (
    <Container
      variant="fullWidth"
      sx={{
        position: 'relative',
        ml: 0,
        height: 'auto',
        '.slick-dots': {
          position: 'relative',
          pt: ['calc(3.2rem - 2rem + .8rem)', 'calc(3.2rem - 2rem + .8rem)'],
          height: '100%',
          bottom: 0,
        },
        '.slick-dots li': {
          width: '0.8rem',
          height: '0.8rem',
          margin: 0,
          zIndex: 1,
          button: {
            width: '0.8rem',
            height: '0.8rem',

            padding: 0,
            borderRadius: '50%',
            backgroundColor: 'black',
            opacity: 0.2,

            '::before': {
              content: '""',
              display: 'none',
            },
          },
          '&.slick-active button': {
            opacity: 1,
          },
          ':not(:last-of-type)': {
            marginRight: '0.8rem',
          },
        },
        ...forwardSx,
      }}
    >
      <Slider
        {...{
          length: length ?? 0,
          dots: true,
          arrows: true,
          accessibility: true,
          beforeChange: () => setDragging(true),
          afterChange: () => setDragging(false),
          ...sliderSettings,
        }}
        prevArrow={
          <SliderButton
            aria-label="Previous card"
            forwardSx={{
              bottom: '0px',
              top: null,
              transform: 'none',
              position: 'absolute',
              left: ['2rem', null, '3rem'],
              transform: 'rotate(180deg)',
              svg: { stroke: 'black', size: ['2rem', '3rem'] },
              ...arrowSx,
            }}
          >
            <ChevronRightIcon />
          </SliderButton>
        }
        nextArrow={
          <SliderButton
            aria-label="Next card"
            forwardSx={{
              bottom: '0px',
              top: null,
              transform: 'none',
              position: 'absolute',
              right: ['2rem', null, '3rem'],
              svg: { stroke: 'black', size: ['2rem', '3rem'] },
              ...arrowSx,
            }}
          >
            <ChevronRightIcon />
          </SliderButton>
        }
      >
        {children.length &&
          children.map((child, i) => {
            if (isValidElement(child)) return cloneElement(child, { dragging });
          })}
      </Slider>
    </Container>
  );
};

export default GenericSlider;
